// Cookies type
// const cookiesServidor        = 'localhost';
const cookiesServidor         = 'agrishow2023-dashboard.chroma-garden.com';
export const cookiesRegister  = cookiesServidor;

// Cookies name
export const typeCookie       = 'agrishow2023_dash';
export const typeCookiePassw  = 'agrishow2023_passw';
export const typeCookieEmail  = 'agrishow2023_email';
export const typeCookiePage   = 'agrishow2023_page';
export const typeCookiePageId = 'agrishow2023_page_id';
export const typeCookieNewId  = 'agrishow2023_new_id';

// opt box editor
export const config = {
    zIndex: 0,
    readonly: false,
    width: 'auto',
    height: 'auto',
    minHeight: 100,
    direction: '',
    language: 'auto',
    tabIndex: -1,
    buttons: ['bold', 'italic', 'underline', 'image', 'link', 'align', 'paragraph', 'ul', 'ol', 'table', 'source'],
    link: {
        modeClassName: false,
        noFollowCheckbox: false,
        openInNewTabCheckbox: false,
        processPastedLink: false,
        processVideoLink: false,
        selectMultipleClassName: false,
        selectOptionsClassName: false,
    },
    imageDefaultWidth: 24,
    image: {
        dialogWidth: true,
        editAlign: false,
        editAlt: false,
        editBorderRadius: true,
        editClass: false,
        editId: false,
        editLink: true,
        editMargins: false,
        editSize: true,
        editSrc: true,
        editStyle: false,
        editTitle: false,
        openOnDblClick: true,
        selectImageAfterClose: true,
        showPreview: true,
        useImageEditor: true,
    },
    placeholder: "Digite o texto aqui...",
    toolbarAdaptive: false
}

// List month
export const monthList = [
    {
        "name": "Janeiro",
        "month": "01"
    },
    {
        "name": "Fevereiro",
        "month": "02"
    },
    {
        "name": "Março",
        "month": "03"
    },
    {
        "name": "Abril",
        "month": "04"
    },
    {
        "name": "Maio",
        "month": "05"
    },
    {
        "name": "Junho",
        "month": "06"
    },
    {
        "name": "Julho",
        "month": "07"
    },
    {
        "name": "Agosto",
        "month": "08"
    },
    {
        "name": "Setembro",
        "month": "09"
    },
    {
        "name": "Outubro",
        "month": "10"
    },
    {
        "name": "Novembro",
        "month": "11"
    },
    {
        "name": "Dezembro",
        "month": "12"
    }
]
